import parse from 'html-react-parser';

import * as S from './styles';

interface Props {
  titulo: string;
  subTitulo: string | null;
}

function Hero({ titulo, subTitulo }: Props) {
  return (
    <S.HeroSection>
      <S.HeroTitle>{parse(titulo ?? '')}</S.HeroTitle>
      <S.HeroSubtitle>{subTitulo || 'Escolha qual canal de atendimento você deseja'}</S.HeroSubtitle>
    </S.HeroSection>
  );
}

export default Hero;
